module.exports = __webpack_public_path__ + "static/img/schedule_cn.923699a5.png";